import { useFeatureFlagEnabled, useFeatureFlagPayload as usePostHogFeatureFlagPayload } from '@posthog/react';

export type FeatureFlagPayloadMap = {
  'video-cover-upload': { allowedCompanyIds: number[] };
  'floorplan-interactive-editor': { allowedCompanyIds: number[]; allCompanies?: boolean };
  'event-secret-location': Record<string, never>;
  'extra-guests-for-bottle-services': Record<string, never>;
  'widget-config-enable-sign-in': Record<string, never>;
  'widget-config-resale-section': Record<string, never>;
  'widget-config-embed-code-generator': Record<string, never>;
  'admission-image-gallery': Record<string, never>;
  'addon-image-gallery': Record<string, never>;
  'admission-include-drinks': Record<string, never>;
  'addon-terms-and-conditions-link': Record<string, never>;
  'organizer-public-profile': Record<string, never>;
  'event-report-demographics': Record<string, never>;
  'dev-mode': Record<string, never>;
  'delayed-delivery-settings': Record<string, never>;
};

export type FeatureFlag = keyof FeatureFlagPayloadMap;

export const useFeatureFlag = (key: FeatureFlag): boolean => useFeatureFlagEnabled(key) ?? false;

/**
 * The flag's three real states: `undefined` until PostHog has loaded flags, then the boolean.
 *
 * `useFeatureFlag` above collapses `undefined` into `false`, which is the right default for
 * DECIDING WHETHER TO SHOW something but wrong for anything that PERSISTS the answer: a write
 * during the load would be indistinguishable from a real `false`. `DevModeProvider` is the only
 * caller (B2B-2345) — gate features on `useFeatureFlag`.
 */
export const useFeatureFlagState = (key: FeatureFlag): boolean | undefined => useFeatureFlagEnabled(key);

export const useFeatureFlagPayload = <K extends FeatureFlag>(key: K): FeatureFlagPayloadMap[K] | undefined =>
  usePostHogFeatureFlagPayload(key) as FeatureFlagPayloadMap[K] | undefined;
